import React from 'react';

const GALLERY_IMAGES = [
  { src: 'https://images.unsplash.com/photo-1583504386975-0c074131a0b4', alt: 'Wedding celebration', span: '' },
  { src: 'https://images.unsplash.com/photo-1650381125879-39d5820ddcc8', alt: 'Vintage car wedding', span: '' },
  { src: 'https://images.pexels.com/photos/29810065/pexels-photo-29810065.jpeg', alt: 'Elegant celebration', span: '' },
  { src: 'https://images.unsplash.com/photo-1772615071595-f9a1e584b45f', alt: 'Glamorous party', span: 'md:col-span-2' },
  { src: 'https://images.unsplash.com/photo-1523494760603-7629aa714f11', alt: 'Classic wedding', span: '' },
];

export const GallerySection = () => (
  <section id="gallery" className="py-24 bg-white">
    <div className="max-w-7xl mx-auto px-6">
      <h2 className="text-5xl md:text-6xl font-serif text-[#8B7355] mb-4 text-center italic">Moments of Magic</h2>
      <p className="text-xl text-[#8B7355]/80 text-center mb-16">Where memories become timeless treasures</p>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {GALLERY_IMAGES.map((img) => (
          <div key={img.src} className={`relative overflow-hidden rounded-lg group h-80 ${img.span}`}>
            <img
              src={img.src}
              alt={img.alt}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
